export const ENTER = "Enter";
export const SPACE = " ";
export const ESCAPE = "Escape";
export const UP = "ArrowUp";
export const RIGTH = "ArrowRight";
export const DOWN = "ArrowDown";
export const LEFT = "ArrowLeft";
